import React from "react";

export function CloseBoldIcon({ color = '#FFF', ...props }) {
  return (
  <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill={color} {...props}>
    <path d="M20 2.557L2.5641 20L0 17.443L17.4359 0L20 2.557Z" />
    <path d="M2.5641 1.08372e-06L20 17.443L17.4359 20L0 2.557L2.5641 1.08372e-06Z" />
  </svg>
  );
}
